<template>
  <v-row justify="center">
    <v-col lg="4">
      <v-dialog
        v-model="dialogVisible"
        persistent
        width="50%"
      >
        <base-material-card
          class="filter_popup"
          color="primary"
          icon="mdi-filter-outline"
          inline
        >
          <v-card-title>
            <span class="headline">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <div
              v-for="(field, index) in filterStuff"
              :key="'i' + index"
            >
              <v-select
                v-if="field.fieldType.includes('list')"
                v-model="field.fieldValue"
                :items="field.fieldGroupValues"
                :label="field.fieldName"
                clearable
                no-data-text="Нет данных"
              />
              <v-text-field
                v-if="field.fieldType==='text'"
                v-model="field.fieldValue"
                :label="field.fieldName"
                :type="field.fieldType"
              />
              <v-row v-if="field.fieldType==='money'">
                <v-col cols="2">
                  <v-label>{{ field.fieldName }}</v-label>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="field.fieldMoney.min"
                    label="От"
                    type="number"
                  />
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="field.fieldMoney.max"
                    label="До"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row v-if="field.fieldType==='date'">
                <v-col cols="4">
                  <v-select
                    v-model="field.fieldDate.select"
                    :items="selectItems"
                    :label="field.fieldName"
                    @change="onChangeFilterDate($event, index , field)"
                  />
                </v-col>
                <v-col cols="4">
                  <v-menu
                    :ref="'menu' + index"
                    v-model="dateMenuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="auto"
                    offset-y
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="field.fieldDate.disableFrom"
                        :value="formattedDate(field.fieldDate.from)"
                        append-icon="mdi-calendar"
                        clearable
                        readonly
                        v-bind="attrs"
                        @input="onInputDate(index)"
                        v-on="on"
                        @click:clear="onClearDateFrom(index)"
                      />
                    </template>
                    <v-date-picker
                      v-model="field.fieldDate.from"
                      first-day-of-week="1"
                      locale="ru-RU"
                      @change="onChangeDate($event, index)"
                      @input="onInputDate(index)"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-menu
                    v-model="dateMenuTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="auto"
                    offset-y
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="field.fieldDate.disableTo"
                        :value="formattedDate(field.fieldDate.to)"
                        append-icon="mdi-calendar"
                        clearable
                        readonly
                        v-bind="attrs"
                        @input="onInputDate(index)"
                        v-on="on"
                        @click:clear="onClearDateTo(index)"
                      />
                    </template>
                    <v-date-picker
                      v-model="field.fieldDate.to"
                      first-day-of-week="1"
                      locale="ru-RU"
                      @input="onInputDate(index)"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="ml-2 mb-2 btn-hi-primary"
              color="primary darken-1"
              outlined
              rounded
              small
              width="80"
              @click="onApply"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              class="ml-2 mb-2 btn-hi-secondary"
              color="secondary darken-1"
              outlined
              rounded
              small
              width="80"
              @click="onClose"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>

export default {
    name: "FilterDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        filterLabel: {
            type: String,
            default: "filter"
        },
        filterStuff: {
            type: null
        }
    },
    data: () => ({
        filters: [],
        enableDateFrom: ['date', 'period'],
        enableDateTo: ['period'],
        dateMenuFrom: false,
        dateMenuTo: false,
        selectItems: [{ value: 'beforeyesterday', text: 'Позавчера' }, {
            value: 'yesterday',
            text: 'Вчера'
        }, { value: 'today', text: 'Сегодня' }, { value: 'date', text: 'Конкретная дата' }, {
            value: 'period',
            text: 'Период дат'
        }],
    }),
    methods: {
        fillTitle () {
            const filterStuff = this.filterStuff.map(fs => {
                if (fs.fieldType === 'text' && fs.fieldValue.length > 0) {
                    return { ...fs, fieldTitle: `${fs.fieldName}: ${fs.fieldValue}` }
                } else if (fs.fieldType === 'money' && Object.keys(fs.fieldMoney).length > 0) {
                    let template = `${fs.fieldName}:`
                    template = 'min' in fs.fieldMoney ? `${template} ${fs.fieldMoney.min}/ ` : `${template}: / `
                    template = 'max' in fs.fieldMoney ? `${template}${fs.fieldMoney.max}` : `${template}`
                    return { ...fs, fieldTitle: template }
                } else if (fs.fieldType.includes('list') && fs.fieldValue.toString().length > 0) {
                    let template = `${fs.fieldName}:`
                    const index = fs.fieldGroupValues.findIndex(f => f.value == fs.fieldValue)
                    template = template + fs.fieldGroupValues[index].text
                    return { ...fs, fieldTitle: template }
                } else if (fs.fieldType === 'date' && (Object.hasOwn(fs.fieldDate, 'from') || Object.hasOwn(fs.fieldDate, 'to'))) {
                    let template = `${fs.fieldName}: `
                    template = Object.hasOwn(fs.fieldDate, 'from') ? template + this.formattedDate(fs.fieldDate.from) + '/' : template + ' /'
                    template = Object.hasOwn(fs.fieldDate, 'to') ? template + this.formattedDate(fs.fieldDate.to) : template
                    return { ...fs, fieldTitle: template }
                } else {
                    return fs
                }
            })
            // console.log('fillTitle filterStuff', filterStuff)
            return filterStuff
        },
        formattedDate: function (date) {
            // console.log('formattedDate this.filterStuff', this.filterStuff)
            let formattedDate = ""
            const options = {
                weekday: "short",
                year: "numeric",
                month: "2-digit",
                day: "numeric"
            }
            if (date) {
                formattedDate = new Date(date).toLocaleDateString('ru-RU', options)
            }
            return formattedDate
        },
        onApply () {
            const filterStuff = this.fillTitle()
            localStorage.setItem(this.filterLabel, JSON.stringify(filterStuff))
            console.log('onApply filterStuff', this.filterStuff)
            this.$emit("filter")
        },
        onChangeDate (event, index) {
            console.log('onChangeDate event', event)
            console.log('onChangeDate index', index)
        },
        onChangeFilterDate (value, index, field) {
            console.log('onChangeFilterDate index', index)
            console.log('onChangeFilterDate value', value)
            const today = new Date()
            if (value === 'today') {
                this.filterStuff[index].fieldDate.from = new Date().toISOString().slice(0, 10)
            } else if (value === 'yesterday') {
                today.setDate(today.getDate() - 1)
                this.filterStuff[index].fieldDate.from = today.toISOString().split('T')[0]
            } else if (value === 'beforeyesterday') {
                today.setDate(today.getDate() - 2)
                this.filterStuff[index].fieldDate.from = today.toISOString().split('T')[0]
            } else if (value === 'date') {
                this.filterStuff[index].fieldDate.from = new Date().toISOString().slice(0, 10)
            }
            this.filterStuff[index].fieldDate.disableFrom = !this.enableDateFrom.includes(value)
            this.filterStuff[index].fieldDate.disableTo = !this.enableDateTo.includes(value)
            this.$forceUpdate()
            // console.log('onChangeFilterDate this.filterStuff', this.filterStuff)
        },
        onClearDateFrom (index) {
            delete this.filterStuff[index].fieldDate.from
            if (!('to' in this.filterStuff[index].fieldDate)) {
                this.filterStuff[index].fieldTitle = ''
            }
        },
        onClearDateTo (index) {
            delete this.filterStuff[index].fieldDate.to
            if (!('from' in this.filterStuff[index].fieldDate)) {
                this.filterStuff[index].fieldTitle = ''
            }
        },
        onClearMoneyMax (index) {
            delete this.filterStuff[index].fieldMoney.max
            if (!('min' in this.filterStuff[index].fieldMoney)) {
                this.filterStuff[index].fieldTitle = ''
            }
        },
        onClearMoneyMin (index) {
            // delete this.filterStuff[index].fieldMoney.min
            //   Reflect.deleteProperty(this.filterStuff[index].fieldMoney, 'min')
            this.filterStuff[index].fieldMoney = Object.fromEntries(Object.entries(this.filterStuff[index].fieldMoney).filter(([key]) => !key.includes('min')))
            console.log('++ onClearMoneyMin this.filterStuff', this.filterStuff)
            if (!('max' in this.filterStuff[index].fieldMoney)) {
                this.filterStuff[index].fieldTitle = ''
            }
        },
        onClose () {
            this.$emit("close")
        },
        onInputDate (index) {
            console.log('newDate', index)
            this.dateMenuFrom = false
            this.dateMenuTo = false
        },
    }
}
</script>

<style scoped>

</style>
